import ConstituentQueryTypeFields from '@/constants/constituents/ConstituentQueryTypeFields';
import ConstituentSearchColumn from '@/constants/ConstituentSearchColumn';
import ConstituentSearchFilterField from '@/constants/ConstituentSearchFilterField';
import FilterOperator from '@/constants/forms/FilterOperator';
import { createApiRequest } from '@/utils/services';

export const fetchCardsByColumn = ({ ownerOrgId, columnId, params = {} }) => {
  const { filters = [], pageSize, pageFrom, sortBy, sortOrder } = params;
  return createApiRequest({
    method: 'post',
    path: `orgs/${ownerOrgId}/constituents/search`,
    data: {
      queryType: ConstituentQueryTypeFields.V4,
      pageFrom,
      pageSize,
      sortBy,
      sortOrder,
      columns: [
        ConstituentSearchColumn.AVATAR,
        ConstituentSearchColumn.INCOMPLETE_TASKS,
        ConstituentSearchColumn.DISPLAY_NAME,
        ConstituentSearchColumn.CONSTITUENT_RULES,
        ConstituentSearchColumn.CONSTITUENT_CATEGORIES,
      ],
      filters: [
        ...filters,
        {
          field: ConstituentSearchFilterField.COLUMN_IDS,
          operator: FilterOperator.ANY,
          value: [columnId],
        },
      ],
    },
  });
};

export const createLifecycleBoard = (data) =>
  createApiRequest({ data, method: 'post', path: 'boards', throwErrors: true });

export const deleteLifecycleBoard = (boardId) =>
  createApiRequest({
    method: 'delete',
    path: `boards/${boardId}`,
    throwErrors: true,
  });

export const updateLifecycleBoard = (boardId, data = {}) =>
  createApiRequest({
    data,
    method: 'put',
    path: `boards/${boardId}`,
    throwErrors: true,
  });

export default {
  createLifecycleBoard,
  deleteLifecycleBoard,
  fetchCardsByColumn,
  updateLifecycleBoard,
};
